import { locationPathLabel, type LocationNode } from '@oscom/shared';

/** Ancestor names of a location, joined for display; unknown ids are skipped. */
export function locationPath(locationId: string, byId: ReadonlyMap<string, LocationNode>): string {
  const node = byId.get(locationId);
  if (!node) return '';
  const ancestors = node.path
    .map((id) => byId.get(id))
    .filter((entry): entry is LocationNode => entry !== undefined);
  return locationPathLabel(ancestors, ' › ');
}
